import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "Core/logManager";
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";

const INIT_STATE = {
  loading: false,
  driverResponse: null,
  error: null,
  openDelete: false,
  selectedItems: [],
};

const route = "modules/settings/views/driver/components/changeStatus/redux/slice";

export const deleteDriver = createAsyncThunk(
  `${route}/deleteDriver`,
  async (payload, { rejectWithValue }) => {

    const { items } = payload;

    try {

        let query = `mutation deleteDrivers ($ids: [Int]!) {deleted: deleteDrivers (ids: $ids)}`;
        const ids = items?.map((item) => item.driverId);

      let response = await clientMutation(
        query,
        {
            ids
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (response) {
        return { driverDelete: response, error: false };
      } else {
        throw "Error while deleting drivers";
      }
    } catch (exc) {
      ExceptionManager(exc, route, "deleteDrivers", true);
      rejectWithValue(exc);
    }
  }
);

export const driverDeleteDriverSliceRedux = createSlice({
  name: "driver/driverDeleteDriver",
  initialState: INIT_STATE,
  reducers: {
    openDriverDeleteModal: (state, action) => {
      state.openDelete = action.payload?.open;
      state.selectedItems = action.payload?.items;
      state.driverResponse = null;
    },
    resetDriverDeleteDriverState: (state, action) => {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    }
  },
  extraReducers: (builder) => {
    //deleteDriver
    builder.addCase(deleteDriver.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(deleteDriver.fulfilled, (state, { payload }) => {

      if(!payload) {
        state.error = "Error while deleting drivers, please try again";
        state.loading = false;

      } else {
        state.loading = false;
        state.driverResponse = payload;
      }
    });
    builder.addCase(deleteDriver.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
  },
});

const { actions, reducer } = driverDeleteDriverSliceRedux;

export const { resetDriverDeleteDriverState, openDriverDeleteModal } = actions;

export default reducer;
